import React from "react";
import { Link } from "react-router-dom";
import './Women.css';
import { Box } from "@chakra-ui/react";
import Slider1 from "../WomenSlider/WomenSlider1";

const Women = () => {

    return(
        <div className="body"> 
        <div className="main_body">
            <div className="Offer_box">
                  <h3>DOUBLE DEAL:20% OFF | 30% OFF until 8/26</h3>
                  <p>SHOP NOW</p>
            </div>
            <div className="Static_img">
                <img src="https://www.yoox.com/images/yoox80/banners/6895_6_GenZ_W_Main.jpg?634485886869569819#width=2961&height=1366" alt="image" />
            </div>
            <div className="salse_container">
                <div className="sale_section">
                    <div className="left">
                        <img src="https://www.yoox.com/images/yoox80/banners/6944_6_Mkd_HL_W_ENG.jpg?634485886869569819#width=430&height=600" alt="image" />
                        <h1 className="heading">THE BIG BIG SALE</h1>
                        <p className="pera"> shop shop shop!</p>
                        <Link to="/womendetails" className="link"><u>SHOP NOW</u></Link>
                    </div>
                    <div className="middle">
                        <h1>DESIGNERS</h1>
                        <p>DOLCE & GABBANA</p>
                        <p>MARNI</p>
                        <p>MAISON MARGIELA</p>
                        <p>CHLOÉ</p>
                        <p>GUCCI</p>
                        <p>BALENCIAGA</p>
                        <p>ROBERTO CAVALLI</p>
                        <p>STELLA MCCARTNEY</p>
                        <p>VERSACE</p>
                        <p>JIL SANDER</p>
                        <Link to="/womendetails" className="link"><u>VIEW LINK</u></Link>
                    </div>
                    <div className="right">
                        <img src="https://www.yoox.com/images/yoox80/banners/6824_1_FocusOnBags_HL_W.jpg?634485886869569819#width=430&height=600" alt="image" />
                        <h1 className="heading">CARRY IT ALL</h1>
                        <p className="pera"> The best bags to keep by your side</p>
                        <Link to="/womendetails" className="link"><u>SHOP NOW</u></Link>
                    </div>
                </div>
            </div>
            <div className="slider_parent">
                <Box className="slider_left_section">
                    <h1>NEW ARRIVALS</h1>
                    <Link to="/womendetails"><u>VIEW ALL</u></Link>
                </Box>
                <Box className="slider_right_section">
                    <Slider1 />
                </Box>
            </div>
        </div>
        <div className="main_middle_section">
            <div className="middle_section">
               <div className="Image_div_left"><img src="https://www.yoox.com/images/yoox80/banners/6825_3_BaumeMercier_Tris_W.png?634485886869569819#width=473&height=660" alt="left" /> <h1>BAUME & MERCIER</h1> <p id="dsc">Don’t miss our selection of watches</p></div>
               <div className="Image_div_middle"><img src="https://www.yoox.com/images/yoox80/banners/6825_9_SeeByChloe_W_Tris.jpg?634485886869569819#width=473&height=660" alt="middle"/> <h1>SEE BY CHLOÉ</h1> <p id="dsc">Don’t miss our selection of watches</p></div>
               <div className="Image_div_right"><img src="https://www.yoox.com/images/yoox80/banners/6825_2_Vans_Tris_WM.jpg?634485886869569819#width=473&height=660" alt="right"/> <h1>VANS</h1> <p id="dsc">Don’t miss our selection of watches</p></div>
            </div>
        </div>
        <div id="bottom_section">
            <div id="bottom_section_both">
                <div className="bottom_section_left">
                    <img src="https://www.yoox.com/images/yoox80/banners/6833_2_8byoox_Teaser_WM_Special.jpg?634485886869569819#width=930&height=660" />

                </div>
                <div className="bottom_section_right">
                     <img src="https://www.yoox.com/images/items/16/16146669NM_14_f.jpg?impolicy=crop&width=306&height=390" />
                     <h1>8 By YOOX</h1>
                     <p>Shell Jacket </p>
                     <p>$ 500</p>
                </div>
            </div>
        </div>
        <div id="last_bottom_section_parent">
            <div className="last_bottom_section">
                <div>
                    <img src="https://www.yoox.com/images/yoox80/banners/6824_1_USopen_HalfBottom.png?634485886869569819#width=690&height=637" alt=""/>

                </div>
                <div>
                   <img src="https://www.yoox.com/images/yoox80/banners/6824_1_NewArrivals_W_HalfBottom.jpg?634485886869569819#width=690&height=637" alt=""/>
                </div>
            </div>
        </div>
        </div>
    )
}

export default Women;